var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 18.8999C8.7 18.8999 6.5 16.5999 6.5 13.8999C6.5 11.0999 8.8 8.8999 11.5 8.8999C14.3 8.8999 16.5 11.1999 16.5 13.8999C16.6 16.5999 14.3 18.8999 11.5 18.8999ZM11.5 10.7999C9.8 10.7999 8.5 12.1999 8.5 13.7999C8.5 15.3999 9.9 16.7999 11.5 16.7999C13.1 16.7999 14.5 15.3999 14.5 13.7999C14.5 12.1999 13.2 10.7999 11.5 10.7999Z",
    fill: "url(#paint0_linear_897_17045)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 30.5C11.2 30.5 10.8 30.3 10.5 30C8.39999 27.8 1.29999 20.3 1.29999 13.8C1.29999 8.1 5.89999 3.5 11.6 3.5C13 3.5 14.3 3.8 15.6 4.3C16.1 4.5 16.4 5.1 16.1 5.6C15.9 6.1 15.3 6.4 14.8 6.1C13.8 5.7 12.7 5.5 11.6 5.5C6.99999 5.5 3.29999 9.2 3.29999 13.8C3.29999 19.3 9.69999 26.4 11.6 28.3C13.3 26.7 17.6 22.1 19.2 17.3C19.4 16.8 19.9 16.5 20.5 16.7C21 16.9 21.3 17.4 21.1 18C19.2 23.5 14.2 28.6 12.7 30.1C12.4 30.4 12 30.5 11.6 30.5Z",
    fill: "url(#paint1_linear_897_17045)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3 8.1998H24.4V3.2998C24.4 2.7998 24 2.2998 23.4 2.2998C22.8 2.2998 22.4 2.6998 22.4 3.2998V8.1998H17.5C17 8.1998 16.5 8.5998 16.5 9.1998C16.5 9.6998 16.9 10.1998 17.5 10.1998H22.4V14.9998C22.4 15.4998 22.8 15.9998 23.4 15.9998C24 15.9998 24.4 15.5998 24.4 14.9998V10.0998H29.3C29.8 10.0998 30.3 9.6998 30.3 9.0998C30.3 8.5998 29.8 8.1998 29.3 8.1998Z",
    fill: "#F2F8F6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_897_17045",
    x1: 2.7878,
    y1: 5.0882,
    x2: 21.4289,
    y2: 23.7293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AD296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009377"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_897_17045",
    x1: 1.84209,
    y1: 6.034,
    x2: 20.4832,
    y2: 24.6751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AD296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009377"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSite);
export default __webpack_public_path__ + "static/media/add-site.78122f4cbf902ed76057488ca841ca1e.svg";
export { ForwardRef as ReactComponent };